import { X } from "lucide-react";
import VoiceInput from "@/components/system/VoiceInput";
import Ni2Icon from "@/components/system/Ni2Icon";

/**
 * Ni² Palette — globally accessible assistant surface.
 * Anchored to the Ni² badge in the title bar.
 */
export default function Ni2Palette({ onClose }) {
  return (
    <div
      className="absolute right-[92px] top-[calc(100%+8px)] z-40 w-[520px] nn-enter"
      role="dialog"
      aria-label="Hey Ni²"
    >
      <div
        className="nn-glass-strong overflow-hidden p-4"
        style={{ borderRadius: 20 }}
      >
        {/* Header */}
        <div className="mb-3 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <Ni2Icon size={28} />
            <div className="leading-tight">
              <div className="text-[13.5px] font-semibold tracking-tight text-[hsl(var(--nn-ink))]">
                Hey Ni²
              </div>
              <div className="text-[11px] text-[hsl(var(--nn-ink-muted))]">
                Search or ask — Ni² infers intent
              </div>
            </div>
          </div>
          <button
            className="nn-icon-btn"
            aria-label="Close"
            onClick={onClose}
            style={{ height: 28, width: 28 }}
          >
            <X className="h-3.5 w-3.5" strokeWidth={1.8} />
          </button>
        </div>

        <VoiceInput testId="ni2-palette-voice" />
      </div>
    </div>
  );
}
